export default __webpack_public_path__ + "static/media/foundingUnsub.ca2743a0.svg";